import React from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';

const InnerProvider = ({ children }) => {
  return <>{children}</>;
};

InnerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const LaunchDarklyProvider = withLDProvider({
  clientSideID: process.env.launchDarklyClientKey,
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
})(InnerProvider);

export { LaunchDarklyProvider };
